import { render, staticRenderFns } from "./_siteCard.vue?vue&type=template&id=63b9f22d"
import script from "./_siteCard.vue?vue&type=script&lang=js"
export * from "./_siteCard.vue?vue&type=script&lang=js"
import style0 from "./_siteCard.vue?vue&type=style&index=0&id=63b9f22d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports